import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';

import { Typography } from '@/components/ui/typography';
import { formatShortDate } from '@/utils/date-util';

import { DateRangePanel } from '../date-range-panel';

interface HiringGoalDateRangeProps {
  startDate: string;
  endDate?: string;
  daysElapsed: number;
  addEndDateUrl: string;
}

export function HiringGoalDateRange({
  startDate,
  endDate,
  daysElapsed,
  addEndDateUrl,
}: HiringGoalDateRangeProps) {
  return (
    <DateRangePanel
      subtitle={
        <FormattedMessage
          defaultMessage="Elapsed: {count, plural, one {# day} other {# days}}"
          description="Elapsed days in the hiring goal; {count} is the number of days"
          values={{ count: daysElapsed }}
        />
      }
    >
      <Typography
        variant="body2"
        className="text-fx-neutral-900 font-medium whitespace-nowrap"
      >
        {formatShortDate(startDate)}
        {' – '}
        {endDate ? (
          formatShortDate(endDate)
        ) : (
          <Link
            to={addEndDateUrl}
            target="_blank"
            className="text-fx-primary underline underline-offset-4 hover:underline"
          >
            <FormattedMessage
              defaultMessage="+ Add end date"
              description="Link to add an end date to the hiring goal"
            />
          </Link>
        )}
      </Typography>
    </DateRangePanel>
  );
}
